import { useEffect} from "react";
import { Link } from "react-router-dom";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();

const TermsList = (props) => {
  const types = [
    {id : 0, type : "무버스 이용 약관"},
    {id : 2, type : "위치기반 서비스 이용"},
    {id : 14, type : "개인정보 처리 방침"},
  ];

  const headerUi = {
    goback: true,
    closeAll: false,
  };
  const pageName = "약관";

  useEffect(() => {
    props.onPageName(pageName);
  }, []);
  useEffect(() => {
    props.onHeaderUi(headerUi);
  }, []);

 

  return (
    <div className="container qna terms_list_wrap">
      <div className="faq_list_wrap">
        <div className="faq_lists">
          {types &&
            types
              .map((item) => {
                return (
                  <Link
                    to={`/terms/${item.id}`}
                    key={item.id}
                    className="faq_list"
                  >
                    <span className="txt_wrap">
                      <span className="faq_list_txt">{item.type}</span>
                    </span>
                    <img src="./img/Right.svg" alt="상세보기" />
                  </Link>
                );
              })}
        </div>
      </div>
    </div>
  );
};
export default TermsList;
